/**
 * Home/Index Controller
 *
 *
 */

// the constructor for this object
function HomeIndexController() { }

// the object
HomeIndexController.prototype = {
    constructor: HomeIndexController,

    // initialize the controller
    init: function()
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();

        // setup the charts
        this._registerCharts();

        // build the accounts dropdown used in the invoice widget
        this._setupAccountsDropdown();

        PortalHelper.debugMessage('Home Controller Initialized');
    },

    // run the controller
    run: function()
    {
        // Populate the users name
        this._populateUserName();

        // get the notification outages
        this._getNotificationOutages();

        // get the notification count
        this._getNotificationCount();

        // Populate the trouble tickets section
        this._getTroubleTickets();

        // Populate the current invoice information
        this._getCurrentInvoice();

        // populate the team box
        this._getTeam();

        // populate the pending orders
        this._getPendingOrders();

        this._getTicketsRequestingResponses();

        // register the events used by this controller
        this._registerEvents();

        PortalHelper.debugMessage('Home Controller Ran');
    },

    // register the chart objects
    _registerCharts: function()
    {
        // create the current invoice dount chart
        var InvoiceChart = new PortalChart;
        InvoiceChart.elementId = 'invoice-chart';
        InvoiceChart.type = 'donut';
        InvoiceChart.dataFormat = 'dollars';
        InvoiceChart.selectEventCallback = this._invoiceChartClick;
        this.InvoiceChart = InvoiceChart;
    },

    // take the user to the list
    _invoiceChartClick: function(rowProperties)
    {
        // set the session saved account id to match the one selected for this account
        var accountId = parseInt($('#account-selection .selection-text').attr('data-account-id'));
        PortalMain.PortalAccounts._storeCurrentAccountId(accountId);

        // go to the services list of the chosen product
        var productCd = rowProperties.productCd.toLowerCase();
        var servicesUrl = PortalConfig.portalUrl + '/services/' + productCd;

        window.location.href = servicesUrl;
    },

    // register the javascript events
    _registerEvents:  function()
    {

    },

    // build the accounts dropdown used in the invoice widget
    _setupAccountsDropdown: function()
    {
        // get the default account id
        var accounts = PortalMain.PortalAccounts.getAccounts();
        if (accounts.length <= 0) {
            var defaultAccountId = false;
        } else {
            var defaultAccountId = accounts[0].account_id;
        }

        // populate the invoice accounts dropdown
        var invoiceAccountSelector =  new PortalAccountSelector();
        invoiceAccountSelector.dropdownStoreAccountId = false;
        invoiceAccountSelector.dropdownAllAccountsOption = false;
        invoiceAccountSelector.dropdownDefaultAccountId = defaultAccountId;
        invoiceAccountSelector.setupAccountsDropdown(
            '#invoice-box #account-selection',
            function(currentAccountId) {
                // show the loading
                PortalHelper.loadingOverlay('#invoice-box .box-content', true);

                // rebuild the current invoice
                PortalMain.HomeIndexController._getCurrentInvoice();
            }
        );
        this.invoiceAccountSelector = invoiceAccountSelector;

        // populate the team accounts dropdown
        var teamAccountSelector = new PortalAccountSelector();
        teamAccountSelector.dropdownStoreAccountId = false;
        teamAccountSelector.dropdownAllAccountsOption = false;
        teamAccountSelector.dropdownDefaultAccountId = defaultAccountId;
        teamAccountSelector.setupAccountsDropdown(
            '#team-box #account-selection',
            function(currentAccountId) {
                // show the loading
                PortalHelper.loadingOverlay('#team-box .box-content', true);

                // rebuild the current invoice
                PortalMain.HomeIndexController._getTeam();
            }
        );
        this.teamAccountSelector = teamAccountSelector;
    },

    // populate the user name into the header
    _populateUserName: function()
    {
        var user = PortalMain.PortalUser.getUser();

        $('#user-name').html(user.first_nm);
    },

    // get the notification outages
    _getNotificationOutages: function()
    {
        var notificationOutagesRequest = new PortalRequest;
        notificationOutagesRequest.makeRequest(
            '/notifications/get-outages',
            {},
            function(data) {
                PortalMain.HomeIndexController._populateNotificationOutages(data);
            }
        );
    },

    // fill in the notification outages
    _populateNotificationOutages: function(data)
    {
        // clear the old tickets
        $('#outages .outage:not(.clone-source)').remove();

        for (var i in data) {
            var outage = data[i];

            var newEntry = $('#outages .clone-source').clone();
            newEntry.removeClass('clone-source');

            // apply the mrc charges
            var message = PortalHelper.breaksToBr(outage.message);
            $('.box-content', newEntry).html(message);

            // add to to the table
            $('#outages').append(newEntry);

        }
    },

    // get the notification count
    _getNotificationCount: function()
    {
        var notificationCountRequest = new PortalRequest;
        notificationCountRequest.makeRequest(
            '/notifications/get-active-cmc-notifications-count',
            {},
            function(data) {
                PortalMain.HomeIndexController._populateNotificationCount(data);
            }
        );
    },

    // fill in the notification counts
    _populateNotificationCount: function(data)
    {
        // handle the upcoming notifications
        if (data.upcomingCount > 0) {
            $('#upcoming-notifications .count').html(data.upcomingCount);
            if (data.upcomingCount > 1) {
                $('#upcoming-notifications .noun').append('s'); // plural
            }
            $('#upcoming-notifications').removeClass('hidden');
        }

        // handle the upcoming notifications
        if (data.recentCount > 0) {
            $('#recent-notifications .count').html(data.recentCount);
            if (data.recentCount > 1) {
                $('#recent-notifications .noun').append('s'); // plural
            }
            $('#recent-notifications').removeClass('hidden');
        }
    },

    // get the trouble tickets
    _getTroubleTickets: function()
    {
        var ticketsRequest = new PortalRequest;
        ticketsRequest.makeRequest(
            '/tickets/get-tickets',
            {
                perPage: 4,
                sort_column: 'last_update_posted',
                sort_order: 'desc'
            },
            function(data) {
                PortalMain.HomeIndexController._populateTroubleTickets(data.data);
            }
        );
    },

    _populateTroubleTickets: function(tickets)
    {
        // clear the old tickets
        $('#trouble-tickets li:not(.clone-source)').remove();

        // add the new tickets to the DOM
        for (var i in tickets) {
            var ticket = tickets[i];
            var newEntry = $('#trouble-tickets .clone-source').clone();
            newEntry.removeClass('clone-source');

            // apply the status
            $('.status', newEntry).html(ticket.status);

            var bulletColor = 'yellow';
            var statusColor = PortalConfig.ticketStatusBulletColors;
            var lowerStatus = ticket.status.toLowerCase();
            if (typeof statusColor[lowerStatus] !== 'undefined') {
                bulletColor = statusColor[lowerStatus];
            }
            newEntry.addClass('bullet-' + bulletColor);

            // apply the order number
            $('.order-number', newEntry).html(ticket.base_order.order_number);

            // apply the subject
            $('.subject', newEntry).html(ticket.subject);

            // apply the link
            var viewLink = PortalConfig.portalUrl;
            viewLink += '/r/tickets/ticket/' + ticket.ticket_id;
            $('.view-link', newEntry).attr('href', viewLink);

            $('#trouble-tickets').append(newEntry);
        }
    },

    _getTicketsRequestingResponses: function()
    {
        var ticketsRequest = new PortalRequest;
        ticketsRequest.makeRequest(
            '/tickets/get-tickets-requesting-response',
            {},
            function(data) {
                PortalMain.HomeIndexController._populateTicketsRequestingResponses(data);
            }
        );
    },

    _populateTicketsRequestingResponses: function(tickets)
    {
        if (tickets.length) {
            $('#tickets-needing-feedback .count').html(tickets.length);
            $('#tickets-needing-feedback').removeClass('hidden');
        }
    },

    // get the current invoice information
    _getCurrentInvoice: function()
    {
        // hide the error messages
        this._hideInvoiceError();

        var accountId = this.invoiceAccountSelector.getDropdownAccountId();

        var invoiceRequest = new PortalRequest;
        invoiceRequest.makeRequest(
            '/invoices/get-latest-invoice',
            {
                accountId: accountId
            },
            function(data) {

                // now get the product breakdown for the chart
                PortalMain.HomeIndexController._getInvoiceProductBreakdown(
                    data.account_id,
                    data.cycle_log_id
                );

                // populate the invoice widget
                PortalMain.HomeIndexController._populateCurrentInvoice(data);
            },
            function(data, code, message) {

                // turn off the loading, and the start-hidden
                PortalHelper.loadingOverlay('#invoice-box .box-content', false);

                PortalMain.HomeIndexController._showInvoiceError(code, message);
            }
        );
    },

    // get the products breakdown of the invoice
    _getInvoiceProductBreakdown: function(accountId, cycleLogId)
    {
        var invoiceProductsRequest = new PortalRequest;
        invoiceProductsRequest.makeRequest(
            '/invoices/get-invoice-products',
            {
                accountId: accountId,
                cycleLogId: cycleLogId
            },
            function(data) {
                // fill the invoice chart data
                PortalMain.HomeIndexController._populateInvoiceChart(data);

                // turn off the loading, and the start-hidden
                PortalHelper.loadingOverlay('#invoice-box .box-content', false);
            }
        );
    },

    // plug the information into the invoice widget
    _populateCurrentInvoice: function(invoiceData)
    {
        // invoice due date
        var dueDate = PortalHelper.formatDate(invoiceData.due_date);
        var dueDate = 'Due ' + dueDate;
        $('#invoice-due-date').html(dueDate);

        // invoice amount
        var amount = invoiceData.total_amt_due;
        amount = PortalHelper.numberToDollars(amount);
        $('#invoice-amount').html(amount);

        // remaining days
        var dueDate = new Date(invoiceData.due_date);
        var dueDateStamp = dueDate.getTime();
        var currentDate = new Date();
        var currentDateStamp = currentDate.getTime();
        var difference = dueDateStamp - currentDateStamp;
        var days = Math.ceil(difference / (1000 * 60 * 60 * 24)); // divided by one day in milliseconds
        var plural = Math.abs(days) > 1 ? 's' : '';
        if (days <= 0) {
            $('#invoice-remaining-days').remove();
        } else {
            var remainingDays = 'Due in ' + days + ' day' + plural;
            $('#invoice-remaining-days').html(remainingDays);
        }

        // set the pay bill link
        var payLink = PortalConfig.portalUrl + '/invoices/pay';
        $('#invoice-pay-link').attr('href', payLink);

        // set the view invoice link
        var viewLink = PortalConfig.portalUrl + '/invoices/view';
        viewLink += '/' + invoiceData.account_id + '/' + invoiceData.cycle_log_id;
        $('#invoice-view-link').attr('href', viewLink);
    },

    // plug the invoice products data into the chart
    _populateInvoiceChart: function(invoiceData)
    {
        // remove the hidden class
        $('#chart-column').removeClass('hidden');

        // format the data for use in the chart
        var chartData = [
            ['Service', 'Price']
        ];
        for (var i in invoiceData) {

            // ensure the price isn't a negative number
            var productPrice = invoiceData[i].price < 0 ? 0 : invoiceData[i].price;

            chartData.push([
                invoiceData[i].short_product_name,
                productPrice
            ]);
        }

        // if data has a total price of 0, hide the chart
        var totalPrice = 0;
        for (var i in chartData) {
            if (i > 0) { // skip the header row
                totalPrice += parseFloat(chartData[i][1]);
            }
        }

        // get the invoice product codes for use in the select event
        var chartProperties = [];
        for (var i in invoiceData) {
            chartProperties.push({
                productCd: invoiceData[i].product_cd
            })
        }

        this.InvoiceChart.data = chartData;
        this.InvoiceChart.rowProperties = chartProperties;
        this.InvoiceChart.draw();
    },

    // hide the invoice error
    _hideInvoiceError: function(code, message)
    {
        $('#invoice-box .box-content').removeClass('box-error');
        $('#invoice-box .box-content').attr('data-error-message', '');
    },

    // there was an error loading the invoice data from the api, so show the error
    _showInvoiceError: function(code, message)
    {
        $('#invoice-box .box-content')
          .html('')
          .addClass('box-error')
          .attr('data-error-message', message);
    },

    // get the current invoice information
    _getTeam: function()
    {
        var accountId = this.teamAccountSelector.getDropdownAccountId();

        var teamRequest = new PortalRequest;
        teamRequest.makeRequest(
            '/contact/get-team',
            {
                accountId: accountId
            },
            function(data) {
                // populate the team box
                PortalMain.HomeIndexController._populateTeam(data);

                // show the team box
                PortalHelper.loadingOverlay('#team-box .box-content', false);
            }
        );
    },

    // fill in the team details
    _populateTeam: function(data)
    {
        // clear the old team members
        $('#team-box .team-member:not(.clone-source)').remove();

        // build the image url if there is no avatar
        var unknownUserSrc = PortalConfig.hostUrl;
        unknownUserSrc += '/wp-content/themes/element/library/portal/img/unknown-user.png';

        // loop through the team data, using the teamOrder property
        var memberCount = 0;
        for (var i in data) {
            var teamMember = data[i];

            if (teamMember != null) {
                memberCount++;
                var newEntry = $('#team-box .team-member.clone-source').clone();
                newEntry.removeClass('clone-source');

                // apply the avatar
                if (teamMember.avatar) {
                    // if there is an error, show the unknown image
                    $('.avatar', newEntry).one('error', function(){
                        $(this).attr('src', unknownUserSrc);
                    });
                    $('.avatar', newEntry).attr('src', teamMember.avatar);
                } else {
                $('.avatar', newEntry).attr('src', unknownUserSrc);
                }

                // apply the name
                if (teamMember.first_nm) {
                    var name = teamMember.first_nm + ' ' + teamMember.last_nm;
                } else {
                    var name = teamMember.team_title;
                }
                $('.name', newEntry).html(name);

                // apply the title
                if (!teamMember.first_nm) {
                    $('.title', newEntry).remove();
                } else {
                    $('.title', newEntry).html(teamMember.team_title);
                }

                // apply the email
                var mailTo = 'mailto:' + teamMember.email_nm;
                $('.email', newEntry).attr('href', mailTo);
                var emailBreak = teamMember.email_nm.replace('@','<wbr>@');
                $('.email', newEntry).html(emailBreak);

                // apply the phone
                if (teamMember.phones.length > 0) {
                    $('.phone', newEntry).html(teamMember.phones[0].phone);
                } else {
                    $('.phone', newEntry).remove();
                }

                // add to to the team box
                $('#team-box .box-content').append(newEntry);
            }
        }

        // add a trailing box to properly space the flex
        if (memberCount % 3 == 2) {
            $('#team-box .box-content').append('<div class="team-member"></div>');
        }

        // set the pending orders data rows
        $('#team-box').attr('data-team-members', memberCount);
    },

    // get the pending orders
    _getPendingOrders: function()
    {
        var pendingOrdersRequest = new PortalRequest;
        pendingOrdersRequest.makeRequest(
            '/orders/get-pending-orders',
            {
                count: 5
            },
            function(data) {
                // populate the pending orders
                PortalMain.HomeIndexController._populatePendingOrders(data);
            }
        );
    },

    // fill in the pending orders
    _populatePendingOrders: function(data)
    {
        // clear the old team members
        $('#pending-orders li:not(.clone-source)').remove();

        for (var i in data) {
            var order = data[i];

            var newEntry = $('#pending-orders li.clone-source').clone();
            newEntry.removeClass('clone-source');

            // apply the order number
            $('.order-number', newEntry).html(order.order_number);

            // apply the product
            $('.product', newEntry).html(order.product);

            // apply the project manager
            if (!order.project_manager) {
                $('.project-manager', newEntry).remove();
            } else {
                var name = order.project_manager.first_nm + ' ' + order.project_manager.last_nm;
                $('.project-manager', newEntry).html(name);
            }


            var inquiryLink = PortalConfig.portalUrl;
            inquiryLink += '/inquire/pending';
            inquiryLink += '/' + order.order_number;
            inquiryLink += '/' + order.base_order_id;
            $('.inquiry-link', newEntry).attr('href', inquiryLink);

            // add to to the pending orders list
            $('#pending-orders').append(newEntry);

        }
    },

}
